import type { Theme } from '@mui/material/styles';

const getMuiTabs = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      paddingInline: '0px',
      minHeight: 32,
      color: theme.palette.semantic.text.primary,
      overflow: 'hidden',
      /**
       * Desy Customization: align icons to right instead of top
       */
      '& button:has(svg), & button:has(span)': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start' /* Ensures text and SVG align properly */,
        flexDirection: 'row-reverse' /* Reverses the order so SVG appears after text */,
        gap: '8px' /* Adjust the space between text and SVG */,

        '& span': {
          width: '16px',
          marginRight: '5px',
        },
      },
      '&.withBorder': {
        borderBottom: `1px ${theme.palette.semantic.surface.border} solid`,
      },
    }),
    indicator: {
      height: 4,
    },
  },
});
export default getMuiTabs;
